import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { DragDropModule, copyArrayItem, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { OrderFabrication, Operation } from '../../models/of';
import { OfService } from '../../services/of.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-orders-fabrication-list',
  templateUrl: './orders-fabrication-list.component.html',
  styleUrls: ['./orders-fabrication-list.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    DragDropModule,
    MatProgressSpinner,
    MatDividerModule
  ]
})
export class OrdersFabricationListComponent implements OnInit, OnDestroy {
  ordersFabrication: OrderFabrication[] = [];
  isLoading = false;
  displayedColumns: string[] = ['NumOperProd', 'Description', 'QteLancee'];
  
  private destroy$ = new Subject<void>();

  constructor(
    private ofService: OfService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.loadOrdersFabrication();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Charge la liste des ordres de fabrication
   */
  loadOrdersFabrication(): void {
    this.isLoading = true;
    this.ofService.getOrdersFabrication()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.ordersFabrication = data || [];
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Erreur lors du chargement des ordres de fabrication', error);
          this.isLoading = false;
        }
      });
  }

  /**
   * Gère le drop des éléments pour réorganiser la liste
   */
  drop(event: any): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      copyArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

  /**
   * Retourne le libellé de l'en-tête de l'expansion panel
   */
  getHeaderLabel(of: OrderFabrication): string {
    return `${of.Entrepot || ''} | ${of.OpeLignes?.[0]?.Centre || ''} | ${of.OpeLignes?.[0]?.Poste || ''} | OF: ${of.NumOf || ''}`;
  }

  /**
   * Retourne les opérations d'un ordre de fabrication
   */
  getOperations(of: OrderFabrication): Operation[] {
    return of.OpeLignes || [];
  }

  /**
   * Rafraîchit la liste des OF
   */
  refreshList(): void {
    this.loadOrdersFabrication();
  }
}
